import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AdUnitForProductTableDTO } from './types'

export const AD_UNIT_FOR_PRODUCT_TABLE_FRAGMENT: TypedDocumentNode<AdUnitForProductTableDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment AdUnitForProductTableFragment on AdUnit {
    divId
    fieldAlerts {
      ...AlertFragment
    }
    id
    name
    outOfPage
    path
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
